"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftRewardPrizesForAdminResponseToJSON = exports.GetNftRewardPrizesForAdminResponseFromJSONTyped = exports.GetNftRewardPrizesForAdminResponseFromJSON = void 0;
function GetNftRewardPrizesForAdminResponseFromJSON(json) {
    return GetNftRewardPrizesForAdminResponseFromJSONTyped(json, false);
}
exports.GetNftRewardPrizesForAdminResponseFromJSON = GetNftRewardPrizesForAdminResponseFromJSON;
function GetNftRewardPrizesForAdminResponseFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetNftRewardPrizesForAdminResponseFromJSONTyped = GetNftRewardPrizesForAdminResponseFromJSONTyped;
function GetNftRewardPrizesForAdminResponseToJSON(value) {
    return value;
}
exports.GetNftRewardPrizesForAdminResponseToJSON = GetNftRewardPrizesForAdminResponseToJSON;
